import { useContext } from 'react';
import { LoginContext } from '../context';
import { NotWrappedError } from '../functions';
var useLogin = function () {
    var context = useContext(LoginContext);
    if (context === null)
        throw new NotWrappedError();
    return context;
};
export default useLogin;
//# sourceMappingURL=useLogin.js.map